import { Component } from 'react';
import PropTypes from 'prop-types';

import StyledSelect from './StyledSelect';


class ResponsesPageFilterContainer extends Component {
  constructor(props) {
    super(props);

    const {
      responses,
      searchParams: {
        viewed,
        unViewed,
        hasCv,
        noCv,
      },
    } = this.props;

    const vacancyFilterSet = responses.reduce(
      (acc, response) => acc.add(response.title), new Set(),
    );

    const vacancyFilterOptions = [
      { label: 'Все вакансии', value: 0 },
      ...[...vacancyFilterSet].map(value => value && { label: value, value }),
    ];

    this.state = {
      filters: {
        vacancyFilter: {
          options: vacancyFilterOptions,
          value: vacancyFilterOptions.length ? vacancyFilterOptions[0] : null,
        },
      },

      checkboxes: {
        viewedCheckbox: {
          title: 'viewed',
          label: 'Прочитанные',
          value: viewed,
        },
        unViewedCheckbox: {
          title: 'un_viewed',
          label: 'Непрочитанные',
          value: unViewed,
        },

        hasCvCheckbox: {
          title: 'has_cv',
          label: 'Есть резюме',
          value: hasCv,
        },
        noCvCheckbox: {
          title: 'no_cv',
          label: 'Без резюме',
          value: noCv,
        },

      },
    };
  }

  UNSAFE_componentWillReceiveProps(newProps) {
    const { vacancyFilter, statusFilter } = this.state;
    if (vacancyFilter && statusFilter) {
      const {
        vacancyId,
        searchParams: {
          viewed,
          unViewed,
          hasCv,
          noCv,
        },
      } = newProps;
      this.setState(prevState => ({
        filters: {
          vacancyFilter: {
            options: prevState.vacancyFilter.options,
            value: prevState.vacancyFilter.options.find(option => option.value === vacancyId),
          },
        },

        checkboxes: {
          viewedCheckbox: {
            ...prevState.checkboxes.viewedCheckbox,
            value: viewed,
          },
          unViewedCheckbox: {
            ...prevState.checkboxes.unViewedCheckbox,
            value: unViewed,
          },

          hasCvCheckbox: {
            ...prevState.checkboxes.hasCvCheckbox,
            value: hasCv,
          },
          noCvCheckbox: {
            ...prevState.checkboxes.noCvCheckbox,
            value: noCv,
          },

        },
      }));
    }
  }

  onSelectChange = (selectValue, filterKey) => {
    const { filters } = this.state;
    filters[filterKey].value = selectValue;
    this.setState({ filters }, () => this.filterAll());
  };

  onCheckboxChange = (checkEvent, checkboxKey) => {
    const { checkboxes } = this.state;
    const { target } = checkEvent;
    checkboxes[checkboxKey].value = target.checked;
    this.setState({ checkboxes }, () => this.filterAll());
  };

  filterAll = () => {
    const { handleFilterChange } = this.props;
    const {
      filters: { vacancyFilter },
      checkboxes,
    } = this.state;
    const searchParams = new URLSearchParams();
    searchParams.set('page', '1');
    Object.keys(checkboxes).forEach((checkboxKey) => {
      searchParams.append(checkboxes[checkboxKey].title, checkboxes[checkboxKey].value);
    });
    handleFilterChange(vacancyFilter.value.value, searchParams.toString());
  };

  render() {
    const {
      filters,
      checkboxes,
    } = this.state;
    const filtersContainers = Object.keys(filters).map(filterKey => (
      <StyledSelect
        key={filterKey}
        options={filters[filterKey].options}
        value={filters[filterKey].value}
        onChange={selectValue => this.onSelectChange(selectValue, filterKey)}
        isSearchable={false}
      />
    ));
    const checkboxesContainer1 = Object.keys(checkboxes).slice(0, 2).map(checkboxKey => (
      <label className="checkbox-container" key={checkboxKey}>
        {checkboxes[checkboxKey].label}
        <input
          className="checkbox-hidden"
          name="doesNotHaveCv"
          type="checkbox"
          checked={checkboxes[checkboxKey].value}
          onChange={checkEvent => this.onCheckboxChange(checkEvent, checkboxKey)}
        />
        <span className="checkbox-mark" />
      </label>
    ));
    const checkboxesContainer2 = Object.keys(checkboxes).slice(2).map(checkboxKey => (
      <label className="checkbox-container" key={checkboxKey}>
        {checkboxes[checkboxKey].label}
        <input
          className="checkbox-hidden"
          name="doesNotHaveCv"
          type="checkbox"
          checked={checkboxes[checkboxKey].value}
          onChange={checkEvent => this.onCheckboxChange(checkEvent, checkboxKey)}
        />
        <span className="checkbox-mark" />
      </label>
    ));
    return (
      <div className="responses-page-filter-container">
        {filtersContainers}
        <div className="responses-checkboxes">
          <div className="responses-checkboxes-group">
            {checkboxesContainer1}
          </div>
          <div className="responses-checkboxes-group">
            {checkboxesContainer2}
          </div>
        </div>
      </div>
    );
  }
}

ResponsesPageFilterContainer.propTypes = {
  responses: PropTypes.arrayOf(PropTypes.object).isRequired,
  searchParams: PropTypes.object.isRequired,
  handleFilterChange: PropTypes.func.isRequired,
};

export default ResponsesPageFilterContainer;
